
import React, { useState, useEffect, useRef } from 'react'
import Breadcrumb from '../../../../Components/Utils/Breadcrumb'
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { NuInput } from '../../../../Components/Utils/Input';
import { useFormik } from 'formik';
import EditIcon from '../../../../Components/Icons/Edit';
import { Select } from 'antd';
import DeleteIcon from '../../../../Components/Icons/Delete';
import useAddFormData from '../../../../Components/Hooks/useAddFormData';
import * as yup from "yup";
import Plus from '../../../../Components/Icons/Plus';
import Attachement from '../../../../Components/Utils/CustomAttrachmentupload';
import SignatureCanvas from 'react-signature-canvas';
import { useToast } from '../../../../Components/Others/ToastServices';
import UseGetDataSearchlist from '../../../../Components/Hooks/useFetchDataByListing';
import axiosInstance from '../../../../Services/axiosCommon';

function FireFrom() {
    const location = useLocation();
    const navigate = useNavigate();
    const { id, formId, scheduleViewId} = useParams();
    const toast = useToast();
    
    const pageIndex = location.state?.pageIndex;
    const searchQuery = location.state?.searchQuery;
    const form_data = location?.state?.form;
    const inspectiionId = form_data?.inspectiionId;
    const [params, setParams] = useState({});

    const { data, getData, totalCount, dataLoading } = UseGetDataSearchlist(
        `/fieldservicereport/get_by_id/${inspectiionId}`,
        params
    );

    useEffect(() => {
        if (inspectiionId) {
            getData();
        }
    }, [inspectiionId]);

    useEffect(() => {
        if (data && data.data) {
            populateFormData(data.data);
        }
    }, [data]);

    useEffect(() => {
        if (data && data.status === false) {
            toast.error("Form data not found");
        }
    }, [data, toast, inspectiionId]);

    const [Equipitems, setEquipItems] = useState([]);
    const [isSubmited, setIsSubmited] = useState(false);
    const { Oncancel, addFormData, isLoading } = useAddFormData();
    const [selectedFile, setSelectedFile] = useState(null);
    const [isSaving, setIsSaving] = useState(false);

    const [formData, setFormData] = useState({
        isSubmited: false,
        facilityName: '',
        facilityAddress: '',
        testType: 'Monthly',
        inspectorCertification: '',
        testDate: '',
        inspectorName: '',
        manufacturer: '',
        model: '',
        serialNumber: '',
        fuelType: 'Diesel',
        ratedPower: '',
        ratedVoltage: '',
        ratedFrequency: '',
        loadPercentage: '',
        runTime: '',
        oilPressure: '',
        coolantTemp: '',
        batteryVoltage: '',
        fuelLevel: '',
        voltageOutput: '',
        frequencyOutput: '',
        issuesFound: '',
        correctiveActions: '',
        nextTestDate: '',
        ambientTemperature: '',
        humidity: '',
        weatherConditions: 'Clear',
        generalCondition: "Good",
        corrosionPresent: false,
        leaksPresent: false,
        mountingSecure: false,
        ventilationAdequate: false,
        fuelLevel: "",
        fuelQuality: "Good",
        fuelFilterCondition: "Good",
        fuelPumpOperation: "Normal",
        fuelLinesSecure: false,
       
        observation: "",
        action_acquired: "",
        person1: "",
        empcode: "",
        contactNo: "",
        date: "",
        person2: "",
        empcode1: "",
        contactNo1: "",
        date1: "",

        filesToRemove:[]
    });
      const [forms, setForms] = useState([]);
  const form = location.state?.form;
    

    const [serviceType, setServiceType] = useState({
        "Contractual": false,
        "Non -Contractual": false, 
        "Comprehensive": false,
        "Semi-Comprehensive": false,
        "Non-Comprehensive": false,
        "Monthly": false,
        "Quarterly": false,
        "On Call": false,
        "Emergency Call": false,
        "Others": false,
        "Inspection": false,
        "General Service": false,
        "Repair Works": false,
        "New Installations": false
    });

    const [systemType, setSystemType] = useState({
        "Water Based Sprinkler System": false,
        "Foam Based Sprinkler System": false,
        "Stand Pipe & Hose System": false,
        "Deluge System": false,
        "Pre-Action System": false,
        "Fire Suppression System": false,
        "Fire Alarm System": false,
        "Fire Extinguishers": false,
        "Aspirating Smoke Detector System": false,
        "Emergency & Exit Light System": false,
        "Fire Hydrant": false,
        "Fire Pump": false,
        "Breeching Inlet / FDC": false,
        "Voice Evacuation System/PAVA": false,
        "Central Battery System": false,
        "Others": false
    });

    const [isEquipmentEditable, setIsEquipmentEditable] = useState(false);
    const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState(null);

    const clientSigCanvas = useRef(null);
    const falconSigCanvas = useRef(null);
    const [signatures, setSignatures] = useState({
        client: null,
        falcon: null
    });

   
    const formikAddEquipment = useFormik({
        initialValues: {
            name: "",
            startdate: "",
            enddate: "",
            totalhours: "",
            noofperson: ""
        },
        validateOnChange: false,
        validateOnBlur: false,
    });

    const [equipmentProductError, setEquipmentProductError] = useState("");
    const [equipmentCatError, setEquipmentCatError] = useState("");
    const [equipmentUnitError, setEquipmentUnitError] = useState("");
    const [equipmentQuantityError, setEquipmentQuantityError] = useState("");
    const [equipmentError, setEquipmentError] = useState("");

   const populateFormData = (apiData) => {
    if (!apiData) return;


   
    setFormData(prev => ({
        ...prev,
        observation: apiData.observation || "",
        action_acquired: apiData.action_acquired || "",
        person1: apiData.falcon_fire?.authorisedperson || "",
        empcode: apiData.falcon_fire?.Employeecode || "",
        contactNo: apiData.falcon_fire?.contact || "",
        date: apiData.falcon_fire?.date || "",
        person2: apiData.client?.authorisedperson || "",
        empcode1: apiData.client?.Employeecode || "",
        contactNo1: apiData.client?.contact || "",
        date1: apiData.client?.date || "",
        isSubmited: apiData.isSubmited || false
    }));

    
    if (apiData.inspector_details && Array.isArray(apiData.inspector_details)) {
        const techData = apiData.inspector_details.map(item => ({
            name: item.name || "",
            startdate: item.startdate?.split(' ')[0] || "",
            enddate: item.enddate?.split(' ')[0] || "",
            totalhours: item.totalhours?.toString() || "",
            noofperson: item.noofperson?.toString() || ""
        }));
        setTech(techData.length > 0 ? techData : [{ name: "", startdate: "", enddate: "", totalhours: "", noofperson: "" }]);
    }


    if (apiData.inspection_type) {
        setServiceType(prev => ({ 
            ...prev, 
            ...apiData.inspection_type 
        }));
    }

   
    if (apiData.types_of_system) {
        setSystemType(prev => ({ ...prev, ...apiData.types_of_system }));
    }

    
    if (apiData.damages && Array.isArray(apiData.damages)) {
        const damagesData = apiData.damages.map(damage => ({
            description: damage.description || "",
            quantity: damage.quantity?.toString() || ""
        }));
        setDamages(damagesData.length > 0 ? damagesData : [{ description: "", quantity: "" }]);
    }

    
    setIsSubmited(apiData.isSubmited || false);
    
   
    if (apiData.falcon_fire?.signature) {
        setSignatures(prev => ({ ...prev, falcon: apiData.falcon_fire.signature }));
      
        setTimeout(() => {
            if (falconSigCanvas.current && apiData.falcon_fire.signature) {
                loadSignatureToCanvas("falcon", apiData.falcon_fire.signature);
            }
        }, 100);
    }
    if (apiData.client?.signature) {
        setSignatures(prev => ({ ...prev, client: apiData.client.signature }));
      
        setTimeout(() => {
            if (clientSigCanvas.current && apiData.client.signature) {
                loadSignatureToCanvas("client", apiData.client.signature);
            }
        }, 100);
    }
};


const loadSignatureToCanvas = (type, signatureData) => {
    try {
        if (type === "falcon" && falconSigCanvas.current) {
            falconSigCanvas.current.fromDataURL(signatureData);
        } else if (type === "client" && clientSigCanvas.current) {
            clientSigCanvas.current.fromDataURL(signatureData);
        }
    } catch (error) {
        console.error("Error loading signature to canvas:", error);
    }
};

    const handleServiceTypeChange = (key) => {
        setServiceType(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const handleSystemTypeChange = (key) => {
        setSystemType(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({ 
            ...prev, 
            [name]: type === 'checkbox' ? checked : value 
        }));
    };

    const handleAddEquipment = () => {
        let hasError = false;
        
        
        setEquipmentCatError("");
        setEquipmentProductError("");
        setEquipmentUnitError("");
        setEquipmentQuantityError("");

      
        if (!formikAddEquipment.values.name) {
            setEquipmentCatError("Required");
            hasError = true;
        }
        if (!formikAddEquipment.values.startdate) {
            setEquipmentCatError("Required");
            hasError = true;
        }
        if (!formikAddEquipment.values.enddate) {
            setEquipmentProductError("Required");
            hasError = true;
        }
        if (!formikAddEquipment.values.totalhours) {
            setEquipmentUnitError("Required");
            hasError = true;
        }
        if (!formikAddEquipment.values.noofperson) {
            setEquipmentQuantityError("Required");
            hasError = true;
        }
        
        if (hasError) return;

        
        const newItem = {
            name: formikAddEquipment.values.name,
            startdate: formikAddEquipment.values.startdate,
            enddate: formikAddEquipment.values.enddate,
            totalhours: formikAddEquipment.values.totalhours,
            noofperson: formikAddEquipment.values.noofperson,
        };
        
        setEquipItems([...Equipitems, newItem]);
        formikAddEquipment.resetForm();
        setEquipmentError("");
    };


useEffect(() => {
  const handleResize = () => {
    if (signatures.falcon && falconSigCanvas.current) {
      falconSigCanvas.current.fromDataURL(signatures.falcon);
    }
    if (signatures.client && clientSigCanvas.current) {
      clientSigCanvas.current.fromDataURL(signatures.client);
    }
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, [signatures]);

const clearSignature = (type) => {
  if (type === "client" && clientSigCanvas.current) {
    clientSigCanvas.current.clear();
    setSignatures((prev) => ({ ...prev, client: null }));
  } else if (type === "falcon" && falconSigCanvas.current) {
    falconSigCanvas.current.clear();
    setSignatures((prev) => ({ ...prev, falcon: null }));
  }
};

const saveSignature = (type) => {
  try {
    if (type === "client" && clientSigCanvas.current) {
      const dataURL = clientSigCanvas.current.toDataURL("image/png");
      setSignatures((prev) => ({ ...prev, client: dataURL }));
      toast.open({
        type: "success",
        message: "Client signature saved locally",
      });
      return dataURL;
    } else if (type === "falcon" && falconSigCanvas.current) {
      const dataURL = falconSigCanvas.current.toDataURL("image/png");
      setSignatures((prev) => ({ ...prev, falcon: dataURL }));
      toast.open({
        type: "success",
        message: "Falcon signature saved locally",
      });
      return dataURL;
    }
    return null;
  } catch (error) {
    console.error("Error saving signature:", error);
    toast.error("Failed to save signature");
    return null;
  }
};

const handleCanvasClick = (type) => {
  if ((type === "client" && signatures.client) || (type === "falcon" && signatures.falcon)) {
    toast.open({
      type: "warning",
      message: `Please clear the existing ${type} signature before adding a new one`,
    });
    return false;
  }
  return true;
};

    const [image, setImage] = useState([]);

    function handleImageChange(e) {
        const maxFileSize = 200000000; 
        const files = Array.from(e.target.files);
        let fileArr = [];

        files.forEach((item) => {
            if (item.size < maxFileSize) {  
                fileArr.push(item);
            } else {
                toast.open({
                    type: "warning",
                    message: `File Size too big`,
                    description: `${item.name} is removed and not uploaded`,
                });
            }
        });

        setSelectedFile(fileArr);
        setImage(fileArr);
        e.target.value = null;
    }

    const removeImages = (value) => {
        let List = selectedFile.filter((item) => item?.name !== value?.name);
        setSelectedFile([...List]);
        setImage(List);
    };

    const handleDeleteItem = (indexToDelete) => {
        const updatedItems = Equipitems.filter((_, index) => index !== indexToDelete);
        setEquipItems(updatedItems);
        setIsDeletePopupOpen(false);
        setDeleteInfo(null);
    };

    const handleQuantityChange = (e, index) => {
        const updatedQuantity = e.target.value;
        const updatedItems = Equipitems.map((item, idx) => {
            if (idx === index) {
                return { ...item, noofperson: updatedQuantity };
            }
            return item;
        });
        setEquipItems(updatedItems);
    };

    const handleTotalHoursChange = (e, index) => {
        const updatedHours = e.target.value;
        const updatedItems = Equipitems.map((item, idx) => {
            if (idx === index) {
                return { ...item, totalhours: updatedHours };
            }
            return item;
        });
        setEquipItems(updatedItems);
    };

    const [tech, setTech] = useState(
        Array(1).fill().map(() => ({ 
            name: "", 
            startdate: "", 
            enddate: "", 
            totalhours: "", 
            noofperson: "" 
        }))
    );

    const [damages, setDamages] = useState(
        Array(1).fill().map(() => ({ 
            description: "", 
            quantity: "" 
        }))
    );

    const addTechRow = () => {
        setTech([...tech, { name: "", startdate: "", enddate: "", totalhours: "", noofperson: "" }]);
    };

    const removeTechRow = (index) => {
        const newTech = tech.filter((_, i) => i !== index);
        setTech(newTech);
    };

    const handleTechChange = (index, field, value) => {
        const newTech = [...tech];
        newTech[index][field] = value;
        setTech(newTech);
    };

    const addDamageRow = () => {
        setDamages([...damages, { description: "", quantity: "" }]);
    };

    const removeDamageRow = (index) => {
        const newDamages = damages.filter((_, i) => i !== index);
        setDamages(newDamages);
    };

    const handleDamageChange = (index, field, value) => {
        const newDamages = [...damages];
        newDamages[index][field] = value;
        setDamages(newDamages);
    };

    const handleDeleteConfirm = () => {
        if (deleteInfo) {
            if (deleteInfo.type === "tech") {
                removeTechRow(deleteInfo.index);
            } else if (deleteInfo.type === "damage") {
                removeDamageRow(deleteInfo.index);
            }
        }
        setIsDeletePopupOpen(false);
    };

   const prepareSubmissionData = (isSubmit = false) => {
   
    const completeServiceType = {
        "Contractual": serviceType["Contractual"] || false,
        "Non -Contractual": serviceType["Non -Contractual"] || false, 
        "Comprehensive": serviceType["Comprehensive"] || false,
        "Semi-Comprehensive": serviceType["Semi-Comprehensive"] || false,
        "Non-Comprehensive": serviceType["Non-Comprehensive"] || false,
        "Monthly": serviceType["Monthly"] || false,
        "Quarterly": serviceType["Quarterly"] || false,
        "On Call": serviceType["On Call"] || false,
        "Emergency Call": serviceType["Emergency Call"] || false,
        "Others": serviceType["Others"] || false,
        "Inspection": serviceType["Inspection"] || false,
        "General Service": serviceType["General Service"] || false,
        "Repair Works": serviceType["Repair Works"] || false,
        "New Installations": serviceType["New Installations"] || false
    };

    const completeSystemType = {
        "Water Based Sprinkler System": systemType["Water Based Sprinkler System"] || false,
        "Foam Based Sprinkler System": systemType["Foam Based Sprinkler System"] || false,
        "Stand Pipe & Hose System": systemType["Stand Pipe & Hose System"] || false,
        "Deluge System": systemType["Deluge System"] || false,
        "Pre-Action System": systemType["Pre-Action System"] || false,
        "Fire Suppression System": systemType["Fire Suppression System"] || false,
        "Fire Alarm System": systemType["Fire Alarm System"] || false,
        "Fire Extinguishers": systemType["Fire Extinguishers"] || false,
        "Aspirating Smoke Detector System": systemType["Aspirating Smoke Detector System"] || false,
        "Emergency & Exit Light System": systemType["Emergency & Exit Light System"] || false,
        "Fire Hydrant": systemType["Fire Hydrant"] || false,
        "Fire Pump": systemType["Fire Pump"] || false,
        "Breeching Inlet / FDC": systemType["Breeching Inlet / FDC"] || false,
        "Voice Evacuation System/PAVA": systemType["Voice Evacuation System/PAVA"] || false,
        "Central Battery System": systemType["Central Battery System"] || false,
        "Others": systemType["Others"] || false
    };

    const falconSignature = signatures.falcon || "";
    const clientSignature = signatures.client || "";


    return {
        inspection_id: id || null,
        isSubmited: isSubmit,
        inspector_details: tech.filter(item => item.name || item.startdate || item.enddate).map(item => ({
            name: item.name || "",
            startdate: item.startdate ? `${item.startdate} 00:00:00` : "",
            enddate: item.enddate ? `${item.enddate} 00:00:00` : "",
            totalhours: parseInt(item.totalhours) || 0,
            noofperson: parseInt(item.noofperson) || 0
        })),
        inspection_type: completeServiceType,
        types_of_system: completeSystemType,
        damages: damages.filter(damage => damage.description && damage.quantity).map(damage => ({
            description: damage.description || "",
            quantity: parseInt(damage.quantity) || 0
        })),
        falcon_fire: {
            Employeecode: formData.empcode || "",
            authorisedperson: formData.person1 || "",
            contact: formData.contactNo || "",
            date: formData.date || "",
            signature: falconSignature 
        },
        client: {
            Employeecode: formData.empcode1 || "",
            authorisedperson: formData.person2 || "",
            contact: formData.contactNo1 || "",
            date: formData.date1 || "",
            signature: clientSignature 
        },
        observation: formData.observation || "",
        action_acquired: formData.action_acquired || ""
    };
};

    const validationSchema = yup.object({
        observation: yup.string().required("Observation is required"),
        action_acquired: yup.string().required("Action required is required"),
        person1: yup.string().required("Falcon authorized person is required"),
        person2: yup.string().required("Client authorized person is required"),
        date: yup.date().required("Falcon date is required"),
        date1: yup.date().required("Client date is required"),
    });

const SaveFormData = async () => {
    try {
        setIsSaving(true);
        
        if (!form_data?.inspectiionId) {
            toast.error("Invalid inspection ID");
            return;
        }

        const formDataObj = new FormData();
        const draftData = prepareSubmissionData(false);
        
        formDataObj.append("json_data", JSON.stringify(draftData));

        if (signatures.client && signatures.client !== "") {
            const clientBlob = await dataURLToBlob(signatures.client);
            formDataObj.append("clientSignature", clientBlob, 'client_signature.png');
        }
        
        if (signatures.falcon && signatures.falcon !== "") {
            const falconBlob = await dataURLToBlob(signatures.falcon);
            formDataObj.append("falconSignature", falconBlob, 'falcon_signature.png');
        }

        if (selectedFile && selectedFile.length > 0) {
            selectedFile.forEach((file) => {
                formDataObj.append("attachments", file);
            });
        }

        const response = await axiosInstance.post(
            `/fieldservicereport/submit/${form_data?.inspectiionId}`,
            formDataObj,
            {
                headers: { "Content-Type": "multipart/form-data" },
            }
        );

        if (response.data?.status === true) {
            toast.open({
                type: "success",
                message: "Form saved as draft successfully",
            });
        } else {
            toast.error(response.data?.msg || "Failed to save form");
        }

    } catch (err) {
        console.error("Error saving form:", err);
        toast.error("Failed to save form");
    } finally {
        setIsSaving(false);
    }
};

const formik = useFormik({
    initialValues: formData,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
        try {
            if (!form_data?.inspectiionId) {
                toast.error("Invalid inspection ID");
                return;
            }

            const formDataObj = new FormData();
            
            const submissionData = prepareSubmissionData(true);

            
            
            formDataObj.append("json_data", JSON.stringify(submissionData));

           
            if (signatures.client && signatures.client !== "") {
                const clientBlob = await dataURLToBlob(signatures.client);
                formDataObj.append("clientSignature", clientBlob, 'client_signature.png');
            }
            
            if (signatures.falcon && signatures.falcon !== "") {
                const falconBlob = await dataURLToBlob(signatures.falcon);
                formDataObj.append("falconSignature", falconBlob, 'falcon_signature.png');
            }

         
            if (selectedFile && selectedFile.length > 0) {
                selectedFile.forEach((file) => {
                    formDataObj.append("attachments", file);
                });
            }

            await addFormData({
                url: `/fieldservicereport/submit/${form_data?.inspectiionId}`,
                formData: formDataObj,
                navigateUrl: `/inspection/schedule/newform/${form_data?.inspectiionId}`,
                resetForm: resetForm,
            });

            setSignatures({ client: null, falcon: null });
            setSelectedFile(null);
            clientSigCanvas.current?.clear();
            falconSigCanvas.current?.clear();

        } catch (err) {
            console.error("Error submitting form:", err);
            toast.error("Failed to submit form");
        }
    },
});

    const dataURLToBlob = async (dataURL) => {
        const response = await fetch(dataURL);
        return await response.blob();
    };

    useEffect(() => {
        formik.setValues(formData);
    }, [formData]);
    const formatDateTime = (dateTime) => {
    if (!dateTime) return 'N/A';

    const date = new Date(dateTime);

    const formattedDate = date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).replace(/\//g, '-');

    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

    return `${formattedDate}, ${formattedTime}`;
  };

  const currentForm = forms.find(item => item.id === parseInt(scheduleViewId)) || form;


    return (
        <div className="w-full h-full py-2 px-2 sm:px-4">
            <div className="flex justify-between gap-2 sm:gap-0">
                <Breadcrumb
                    items={[
                        {
                            name: "Schedule",
                            link:`/inspection/schedule/newform/${inspectiionId}`
                        },
                        { name: "Fire Protect" },
                    ]}
                />
                <div className="flex gap-2 justify-start sm:justify-end">
                    <Link
                        to={`/inspection/schedule/newform/${inspectiionId}`}
                        state={{
                            currentPage: pageIndex,
                            searchQuery: searchQuery != "" ? searchQuery : "",
                        }}
                    >
                        <BackButton link={true} />
                    </Link>
                </div>
            </div>
{currentForm && (
              <div className="h-auto  rounded-lg p-2">
                <div className="md:flex gap-4 w-full">
  <div className="flex gap-3">
    <div className="flex items-start">
      <div className=" flex-shrink-0 font-medium text-xs">Schedule :</div>
      <div className="text-[#606279] text-xs flex-1 mx-1">
        {formatDateTime(currentForm.dateTime)}
      </div>
    </div>
    
    <div className="flex items-start">
      <div className=" flex-shrink-0 font-medium text-xs">Assigned To :</div>
      <div className="text-[#606279] font-medium text-xs flex-1 mx-1">
        {currentForm.assignees && currentForm.assignees.length > 0 
          ? currentForm.assignees.map(a => a.assigneeName).join(", ") 
          : 'Unassigned'
        }
      </div>
    </div>
    
    <div className="flex items-start">
      <div className=" flex-shrink-0 font-medium text-xs">Updated by :</div>
      <div className="text-[#606279] text-xs flex-1 mx-1">
        {currentForm.updatedByName || 'None'}
      </div>
    </div>

    <div className="flex items-start">
      <div className=" flex-shrink-0 font-medium text-xs">Last Updated :</div>
      <div className="text-[#606279] font-medium text-xs flex-1 mx-1">
        {currentForm.updatedOn ? formatDateTime(currentForm.updatedOn) : 'Never'}
      </div>
    </div>
  </div>
  
</div>

              </div>
        
            )}

            <div className="bg-white mx-auto  h-[calc(100vh-158px)] w-full rounded-md flex flex-col overflow-y-auto p-2 sm:p-4">

                
                <form onSubmit={formik.handleSubmit}>
                   
                    <div className="bg-white rounded-lg p-4 sm:p-6 mb-4 shadow-sm border border-gray-200">
                        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-2 text-center sm:text-left">
                            FIRE PROTECTION SYSTEM
                        </h1>
                        <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-2 text-center sm:text-left">
                            FIELD SERVICE REPORT
                        </h1>
                    </div>

                    <div className="border p-3 rounded-md mt-3 text-gray-800">
                        <h3 className="font-semibold text-lg sm:text-xl mb-2">
                            TECHNICIANS / INSPECTOR DETAILS 
                        </h3>
                        
                        <div className="border border-gray-300 rounded-md text-xs sm:text-sm mt-3 overflow-x-auto">
                            <table className="w-full border-collapse min-w-[500px]">
                                <thead>
                                    <tr className="text-center font-semibold bg-gray-50">
                                        <th className="border border-gray-300 p-1 sm:p-2">Name</th>
                                        <th className="border border-gray-300 p-1 sm:p-2">Start Date</th>
                                        <th className="border border-gray-300 p-1 sm:p-2">End Date</th>
                                        <th className="border border-gray-300 p-1 sm:p-2">Total Days / Hours</th>
                                        <th className="border border-gray-300 p-1 sm:p-2">No. of Persons</th>
                                        <th className="border border-gray-300 p-1 sm:p-2">
                                            <div className="flex gap-2 items-center justify-center">
                                                <span>Action</span>
                                                <button
                                                    onClick={addTechRow}
                                                    type="button"
                                                    className="p-1 bg-baseColor-primary text-white rounded hover:bg-red-600 transition-colors text-sm"
                                                >
                                                    <Plus size={14} />
                                                </button>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tech.map((row, index) => (
                                        <tr key={index} className="text-center hover:bg-gray-50 transition-colors">
                                            <td className="border border-gray-300 p-1">
                                                <input
                                                    type="text"
                                                    className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                                    value={row.name}
                                                    onChange={(e) => handleTechChange(index, "name", e.target.value)}
                                                    placeholder="Enter Name"
                                                />
                                            </td>
                                            <td className="border border-gray-300 p-1">
                                                <input
                                                    type="date"
                                                    className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                                    value={row.startdate}
                                                    onChange={(e) => handleTechChange(index, "startdate", e.target.value)}
                                                />
                                            </td>
                                            <td className="border border-gray-300 p-1">
                                                <input
                                                    type="date"
                                                    className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                                    value={row.enddate}
                                                    onChange={(e) => handleTechChange(index, "enddate", e.target.value)}
                                                />
                                            </td>
                                            <td className="border border-gray-300 p-1">
                                                <input
                                                    type="text"
                                                    className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                                    value={row.totalhours}
                                                    onChange={(e) => handleTechChange(index, "totalhours", e.target.value)}
                                                    placeholder="Total Days/Hours"
                                                />
                                            </td>
                                            <td className="border border-gray-300 p-1">
                                                <input
                                                    type="number"
                                                    className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                                    value={row.noofperson}
                                                    onChange={(e) => handleTechChange(index, "noofperson", e.target.value)}
                                                    placeholder="No. of Persons"
                                                    min="0"
                                                />
                                            </td>
                                            <td className="border border-gray-300 p-1">
                                                <div className="flex items-center justify-center">
                                                    <button
                                                        onClick={() => {
                                                            setDeleteInfo({ index, type: "tech" });
                                                            setIsDeletePopupOpen(true);
                                                        }}
                                                        type="button"
                                                        className="text-red-500 cursor-pointer p-1 hover:bg-red-50 rounded transition-colors"
                                                       
                                                    >
                                                        <DeleteIcon color="#dc2626" height={16} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="border p-3 rounded-md mt-3">
                        <h3 className="font-semibold text-lg sm:text-xl text-gray-800 mb-2">
                            INSPECTION / SERVICE TYPE
                        </h3>
                        <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 gap-2 text-sm text-gray-800">
                            {Object.keys(serviceType).map((item) => (
                                <label key={item} className="flex items-center justify-between gap-2 p-2 border rounded hover:bg-gray-50 transition-colors">
                                    <span className="text-xs sm:text-sm">{item}</span>
                                    <input
                                        type="checkbox"
                                        checked={serviceType[item]}
                                        onChange={() => handleServiceTypeChange(item)}
                                        className="scale-110"
                                    />
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="border p-3 rounded-md mt-3 text-gray-800">
                        <h3 className="font-semibold text-lg sm:text-xl mb-2">TYPE OF SYSTEMS</h3>
                        <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 gap-2 text-sm">
                            {Object.keys(systemType).map((item) => (
                                <label key={item} className="flex items-center justify-between gap-2 p-2 border rounded hover:bg-gray-50 transition-colors">
                                    <span className="text-xs sm:text-sm">{item}</span>
                                    <input
                                        type="checkbox"
                                        checked={systemType[item]}
                                        onChange={() => handleSystemTypeChange(item)}
                                        className="scale-110"
                                    />
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="border p-3 rounded-md mt-3 text-gray-800">
                        <h3 className="font-semibold text-lg sm:text-xl mb-2">
                            OBSERVATION / CUSTOMER COMPLAINT
                        </h3>
                        <textarea
                            name="observation"
                            value={formData.observation}
                            onChange={handleInputChange}
                            rows={4}
                            className="w-full border border-gray-300 rounded p-3 text-sm resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                            placeholder="Enter observations or complaints here..."
                        />
                        {formik.errors.observation && (
                            <p className="text-red-500 text-xs mt-1">{formik.errors.observation}</p>
                        )}
                    </div>

                    <div className="border p-3 rounded-md text-gray-800 mt-3">
                        <h3 className="font-semibold text-lg sm:text-xl mb-2">
                            ACTION REQUIRED/TAKEN
                        </h3>
                        <textarea
                            name="action_acquired"
                            value={formData.action_acquired}
                            onChange={handleInputChange}
                            rows={4}
                            className="w-full border border-gray-300 rounded p-3 text-sm resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                            placeholder="Enter here..."
                        />
                        {formik.errors.action_acquired && (
                            <p className="text-red-500 text-xs mt-1">{formik.errors.action_acquired}</p>
                        )}
                    </div>

                    <div className="mt-5 text-gray-800">
                        <h3 className="font-semibold text-lg sm:text-xl mb-2">
                            DAMAGES/REPLACEMENT /SPARE PARTS - DETAILS
                        </h3>
                        <div className="border border-gray-300 text-xs sm:text-sm mt-3 overflow-x-auto rounded">
                            <div className="min-w-[400px]">
                                <div className="grid grid-cols-12 border-b border-gray-300 font-semibold text-center bg-gray-50">
                                    <div className="col-span-1 border-r border-gray-300 p-2">S.No.</div>
                                    <div className="col-span-8 border-r border-gray-300 p-2">Description</div>
                                    <div className="col-span-2 border-r border-gray-300 p-2">Qty</div>
                                    <div className="col-span-1 p-2 flex gap-2 items-center justify-center">
                                        <span>Action</span>
                                        <button
                                            onClick={addDamageRow}
                                            type="button"
                                            className="p-1 bg-baseColor-primary text-white rounded hover:bg-red-600 transition-colors text-sm"
                                        >
                                            <Plus size={14} />
                                        </button>
                                    </div>
                                </div>

                                {damages.map((row, index) => (
                                    <div
                                        key={index}
                                        className="grid grid-cols-12 border-b border-gray-200 last:border-b-0 text-center hover:bg-gray-50 transition-colors"
                                    >
                                        <div className="col-span-1 border-r border-gray-300 p-2 flex items-center justify-center text-sm">
                                            {index + 1}
                                        </div>
                                        <div className="col-span-8 border-r border-gray-300 p-2">
                                            <input
                                                type="text"
                                                className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                                value={row.description}
                                                onChange={(e) => handleDamageChange(index, "description", e.target.value)}
                                                placeholder="Enter description..."
                                            />
                                        </div>
                                        <div className="col-span-2 border-r border-gray-300 p-2">
                                            <input
                                                type="number"
                                                className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                                value={row.quantity}
                                                onChange={(e) => handleDamageChange(index, "quantity", e.target.value)}
                                                placeholder="Qty"
                                                min="0"
                                            />
                                        </div>
                                        <div className="col-span-1 p-2 flex items-center justify-center">
                                            <button
                                                onClick={() => {
                                                    setDeleteInfo({ index, type: "damage" });
                                                    setIsDeletePopupOpen(true);
                                                }}
                                                        type="button"

                                                className="text-red-500 hover:text-red-700 transition-colors p-1"
                                            >
                                                <DeleteIcon color="#dc2626" height={16} />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="border border-gray-300 text-xs sm:text-sm mt-5 text-gray-800 overflow-x-auto rounded">
                        <div className="min-w-[600px]">
                            <div className="border-b border-gray-300 text-gray-800 font-semibold text-lg sm:text-xl text-center bg-gray-50">
                                <div className="p-4">ACKNOWLEDGEMENT</div>
                            </div>

                            <div className="grid grid-cols-5 border-b border-gray-300 font-semibold text-center text-gray-800 bg-gray-100">
                                <div className="col-span-1 border-r border-gray-300 p-2">For</div>
                                <div className="col-span-1 border-r border-gray-300 p-2">Authorized Person</div>
                                <div className="col-span-1 border-r border-gray-300 p-2">Employee Code</div>
                                <div className="col-span-1 border-r border-gray-300 p-2">Contact No.</div>
                                <div className="col-span-1 border-r border-gray-300 p-2">Date</div>
                            </div>

                            <div className="grid grid-cols-5 border-b border-gray-300 text-center">
                                <div className="col-span-1 border-r border-gray-300 p-2 font-medium flex items-center justify-center text-xs sm:text-sm bg-gray-50">
                                    Falcon Fire
                                </div>
                                <div className="col-span-1 border-r border-gray-300 p-2">
                                    <input
                                        type="text"
                                        name="person1"
                                        placeholder="Name"
                                        value={formData.person1}
                                        onChange={handleInputChange}
                                        className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                    />
                                    {formik.errors.person1 && (
                                        <p className="text-red-500 text-xs mt-1">{formik.errors.person1}</p>
                                    )}
                                </div>
                                <div className="col-span-1 border-r border-gray-300 p-2">
                                    <input
                                        type="text"
                                        name="empcode"
                                        placeholder="Emp Code"
                                        value={formData.empcode}
                                        onChange={handleInputChange}
                                        className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                    />
                                </div>
                                <div className="col-span-1 border-r border-gray-300 p-2">
                                    <input
                                        type="number"
                                        name="contactNo"
                                        placeholder="Contact"
                                        value={formData.contactNo}
                                        onChange={handleInputChange}
                                        className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                    />
                                </div>
                                <div className="col-span-1 border-r border-gray-300 p-2">
                                    <input
                                        type="date"
                                        name="date"
                                        value={formData.date}
                                        onChange={handleInputChange}
                                        className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                    />
                                    {formik.errors.date && (
                                        <p className="text-red-500 text-xs mt-1">{formik.errors.date}</p>
                                    )}
                                </div>
                            </div>

                            <div className="grid grid-cols-5 text-center">
                                <div className="col-span-1 border-r border-gray-300 p-2 font-medium flex items-center justify-center text-xs sm:text-sm bg-gray-50">
                                    Client
                                </div>
                                <div className="col-span-1 border-r border-gray-300 p-2">
                                    <input
                                        type="text"
                                        name="person2"
                                        placeholder="Name"
                                        value={formData.person2}
                                        onChange={handleInputChange}
                                        className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                    />
                                    {formik.errors.person2 && (
                                        <p className="text-red-500 text-xs mt-1">{formik.errors.person2}</p>
                                    )}
                                </div>
                                <div className="col-span-1 border-r border-gray-300 p-2">
                                    <input
                                        type="text"
                                        name="empcode1"
                                        placeholder="Emp Code"
                                        value={formData.empcode1}
                                        onChange={handleInputChange}
                                        className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                    />
                                </div>
                                <div className="col-span-1 border-r border-gray-300 p-2">
                                    <input
                                        type="number"
                                        name="contactNo1"
                                        placeholder="Contact"
                                        value={formData.contactNo1}
                                        onChange={handleInputChange}
                                        className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                    />
                                </div>
                                <div className="col-span-1 border-r border-gray-300 p-2">
                                    <input
                                        type="date"
                                        name="date1"
                                        value={formData.date1}
                                        onChange={handleInputChange}
                                        className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                    />
                                    {formik.errors.date1 && (
                                        <p className="text-red-500 text-xs mt-1">{formik.errors.date1}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

 {/* <div className="w-full p-6">
  <h2 className="text-xl font-semibold text-gray-800 mb-6">Signature</h2>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
   
    <div className="relative border border-gray-300 rounded-lg p-4 bg-gray-50">
      <div 
        className="w-full h-40 bg-white border border-gray-400 rounded-md overflow-hidden"
        onClick={() => handleCanvasClick("falcon")}
      >
        <SignatureCanvas
          penColor="black"
          canvasProps={{
            width: 500,
            height: 160,
            className: "w-full h-full",
            onMouseDown: () => !handleCanvasClick("falcon") && null,
            onTouchStart: () => !handleCanvasClick("falcon") && null,
          }}
          ref={falconSigCanvas}
        />
      </div>
      <div className="flex justify-between items-center mt-3">
        <span className="text-xs font-semibold text-gray-500">
          Falcon 
        </span>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => clearSignature("falcon")}
            className="text-xs text-red-600 hover:bg-red-100 px-3 py-1 rounded-md transition"
          >
            Clear
          </button>
          <button
            type="button"
            onClick={() => {
              if (signatures.falcon) {
                toast.open({
                  type: "warning",
                  message: "Signature already saved. Please clear first to add a new one.",
                });
                return;
              }
              saveSignature("falcon");
            }}
            className="text-xs bg-baseColor-primary text-white px-3 py-1 rounded-md hover:bg-baseColor-primary transition disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={signatures.falcon}
          >
            {signatures.falcon ? "Saved" : "Save"}
          </button>
        </div>
      </div>
    </div>

   
    <div className="relative border border-gray-300 rounded-lg p-4 bg-gray-50">
      <div 
        className="w-full h-40 bg-white border border-gray-400 rounded-md overflow-hidden"
        onClick={() => handleCanvasClick("client")}
      >
        <SignatureCanvas
          penColor="black"
          canvasProps={{
            width: 500,
            height: 160,
            className: "w-full h-full",
            onMouseDown: () => !handleCanvasClick("client") && null,
            onTouchStart: () => !handleCanvasClick("client") && null,
          }}
          ref={clientSigCanvas}
        />
      </div>
      <div className="flex justify-between items-center mt-3">
        <span className="text-xs font-semibold text-gray-500">
          Client
        </span>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => clearSignature("client")}
            className="text-xs text-red-600 hover:bg-red-100 px-3 py-1 rounded-md transition"
          >
            Clear
          </button>
          <button
            type="button"
            onClick={() => {
              if (signatures.client) {
                toast.open({
                  type: "warning",
                  message: "Signature already saved. Please clear first to add a new one.",
                });
                return;
              }
              saveSignature("client");
            }}
            className="text-xs bg-baseColor-primary text-white px-3 py-1 rounded-md hover:bg-baseColor-primary transition disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={signatures.client}
          >
            {signatures.client ? "Saved" : "Save"}
          </button>
        </div>
      </div>
    </div>
  </div>
</div> */}
                     <div className="flex justify-end gap-4 mt-7">
   <CancelButton
     name={isSaving ? "Saving..." : "Save"}
     handleClick={SaveFormData}
     disabled={isSaving || isLoading}
   />
   <SubmitButton 
     isLoading={isLoading} 
   />
</div>
                </form>
            </div>

            {isDeletePopupOpen && (
                <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
                    <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-auto">
                        <h3 className="text-sm font-medium mb-4">Warning</h3>
                        <p className="mb-6 text-xs">
                            Are you sure you want to delete this row?
                        </p>
                        <div className="flex justify-end space-x-3">
                            <button
                                onClick={() => setIsDeletePopupOpen(false)}
                                className="px-4 py-[8px] text-xs hover:bg-gray-300 rounded-md bg-[#E6F2F2] text-textColor-main"
                            >
                                No
                            </button>
                            <button
                                onClick={handleDeleteConfirm}
                                className="px-4 py-[8px] text-xs bg-textColor-main rounded-md text-white hover:opacity-90"
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default FireFrom